export default "__VITE_ASSET__BWx9gnvd__"